<template>
	<div>
		<Hero/>

        <div id="intro" class="columns">
            <div class="column is-one-third is-hidden-touch">
                <img src="../assets/home/butterfly_on_flower.jpg" class="intro-image">
            </div>
            <div class="column">
                <h3>Welcome</h3>
                <p>
                    This website is built to showcase my software development abilities and make a corner of the internet my own.
                    As more content is added expect to see:
                    <ul>
                        <li>Mockups of website concepts</li>
                        <li>Apps and games built into the site with JavaScript</li>
                        <li>Showcases of my interests such as photography</li>
                        <li>Links to future sites and projects</li>
                    </ul>
                    and all of this served on a static single page site powered by VueJS!
                    <br><br>
                    For more info about me and this website, check out the
                    <router-link class="routerlink" :to="{name: 'About'}">
                        About
                    </router-link>
                    page.
                    <br>
                    Kind Regards, Alex Stefanou
                </p>
            </div>
        </div>

        <div id="projects-intro" class="columns">
            <div class="column">
                <h3>Projects</h3>
                <p>
                    As I have trained in software development,
                    I have built up a repository of past practice projects.
                    <br>
                    I intend to eventually host them on this site,
                    however in the mean time they can be found publically on my GitHub Profile:
                    <br>
                    <a href="https://github.com/Alex-Stefanou/Demonstration-Practice-Code" target="_blank">
                        Demonstration and practice projects
                    </a>
                </p>
            </div>
            <div class="column is-one-third is-hidden-touch">
                <img src="../assets/home/building_construction.jpg" class="intro-image">
            </div>
        </div>

        <div id="gallery-intro" class="columns">
            <div class="column is-one-third">
                <img src="../assets/home/himalayan_summit.jpg" class="intro-image">
            </div>
            <div class="column">
                <h3>Gallery</h3>
                <p>
                    Photography has been one of my favourite hobbies for many years. 
                    I enjoy the balance of precision and creativity photography requires.
                    The creativity to spot an interesting subject, even the most mudane environments, 
                    and achieve the perfect framing to share how you see the world.
                    And the science of getting the perfect shot while factoring in 
                    light, focal distance and stability,
                    <br>
                    <br>
                    This website is the perfect platform to share some of my favourite photos,
                    such as many of the photos on this page!
                    <br>
                    Watch for a gallery coming soon.
                </p>
            </div>
        </div>

        <div id="games-intro" class="columns">
            <div class="column">
                <h3>Games</h3>
                <p>
                    I have enjoyed playing both board games and video games all my life.
                    In particular, turnbased strategy and card games which make for a true battles of wits, much like chess. 
                    And RPGs, both single and multiplayer, which allow you to become totally immersed in a virtual world.
                    <br><br>
                    Naturally, as I began coding, games were some of the first projects I attempted, 
                    starting with simple text-based adventures in C.
                    Since then I have progressed to more complex projects in Unity, 
                    however my love of simple games remains and I plan to make some with just JavaScript for this site.
                    <br><br>
                    Visit the 
                    <router-link class="routerlink" :to="{name: 'Games Home'}">
                        Games
                    </router-link>
                    section of this site to take a look. There are many more to come!
                </p>
            </div>
            <div class="column is-one-third is-hidden-touch">
                <img src="../assets/home/chess_board.jpg" class="intro-image">
            </div>
        </div>
        
        <img src="../assets/home/himalayan_sunrise_edited.png" class="footer-blend-img">
    </div>
</template>

<script>
import Hero from '@/components/home/Hero.vue'
export default {
    name: 'Home',
    components: {
        Hero
    }
}
</script>

<style scoped>
#intro {
    padding: 2rem;
}
#projects-intro {
    background-color: rgb(151, 177, 255);
    padding: 2rem;
}
#gallery-intro {
    background-color: rgb(67, 93, 170);
    color: white;
    padding: 2rem;
}
#games-intro {
    background-color: rgb(23,36,76);
    color: white;
    padding: 2rem;
}

.column {
    padding: 1.5rem;
}
.footer-blend-img {
    margin-top: -2rem;
}
.intro-image {
    margin: auto;
    /* max-width: 400px; */
    min-height: 360px;
    min-width: 220px;
    border-radius: 10px;
    object-fit: cover;
}

h3 {
    font-size: 2rem;
}
li {
    margin-left: 2rem;
}
p {
    margin-top: 0.7rem;
}
ul {
    margin: 5px 0 5px 0;
    list-style-type: disc;
}


</style>
